// 2019 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-05-26)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2019-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2019-masterwork",
//     name: "2019 Topps Star Wars Masterwork",
//     shortName: "2019 Masterwork",
//     year: 2019,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2019",
//     totalCards: 531,
//     description: "Topps 2019 Topps Star Wars Masterwork trading card set.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2019-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "1", name: "Luke Skywalker" },
        { n: "2", name: "Princess Leia Organa" },
        { n: "3", name: "Han Solo" },
        { n: "4", name: "Chewbacca" },
        { n: "5", name: "Lando Calrissian" },
        { n: "6", name: "C-3PO" },
        { n: "7", name: "R2-D2" },
        { n: "8", name: "Yoda" },
        { n: "9", name: "Darth Vader" },
        { n: "10", name: "The Emperor" },
        { n: "11", name: "Boba Fett" },
        { n: "12", name: "Anakin Skywalker" },
        { n: "13", name: "Queen Amidala" },
        { n: "14", name: "Darth Maul" },
        { n: "15", name: "Jango Fett" },
        { n: "16", name: "Qui-Gon Jinn" },
        { n: "17", name: "Mace Windu" },
        { n: "18", name: "Grand Moff Tarkin" },
        { n: "19", name: "Jar Jar Binks" },
        { n: "20", name: "Wicket W. Warrick" },
        { n: "21", name: "IG-88" },
        { n: "22", name: "General Veers" },
        { n: "23", name: "Chief Chirpa" },
        { n: "24", name: "Bail Organa" },
        { n: "25", name: "Jabba the Hutt" },
        { n: "26", name: "Plo Koon" },
        { n: "27", name: "Imperial Stormtrooper" },
        { n: "28", name: "R5-D4" },
        { n: "29", name: "2-1B" },
        { n: "30", name: "Tusken Raider" },
        { n: "31", name: "Nute Gunray" },
        { n: "32", name: "Rune Haako" },
        { n: "33", name: "Owen Lars" },
        { n: "34", name: "Beru Lars" },
        { n: "35", name: "Jawas" },
        { n: "36", name: "Commander Gree" },
        { n: "37", name: "Super Battle Droid" },
        { n: "38", name: "Battle Droid" },
        { n: "39", name: "Rey" },
        { n: "40", name: "Finn" },
        { n: "41", name: "Poe Dameron" },
        { n: "42", name: "Kylo Ren" },
        { n: "43", name: "Vice Admiral Amilyn Holdo" },
        { n: "44", name: "BB-8" },
        { n: "45", name: "Maz Kanata" },
        { n: "46", name: "Rose Tico" },
        { n: "47", name: "Supreme Leader Snoke" },
        { n: "48", name: "Captain Phasma" },
        { n: "49", name: "First Order Stormtrooper" },
        { n: "50", name: "General Hux" },
        { n: "51", name: "DJ" },
        { n: "52", name: "Admiral Ackbar" },
        { n: "53", name: "Nien Nunb" },
        { n: "54", name: "Temiri Blagg" },
        { n: "55", name: "Caretaker" },
        { n: "56", name: "General Ematt" },
        { n: "57", name: "Resistance Soldier" },
        { n: "58", name: "Master Codebreaker" },
        { n: "59", name: "Tallissan \"Tallie\" Lintra" },
        { n: "60", name: "C'ai Threnalli" },
        { n: "61", name: "Anakin Skywalker" },
        { n: "62", name: "Ahsoka Tano" },
        { n: "63", name: "Obi-Wan Kenobi" },
        { n: "64", name: "Captain Rex" },
        { n: "65", name: "Commander Cody" },
        { n: "66", name: "Dengar" },
        { n: "67", name: "Bossk" },
        { n: "68", name: "Hondo Ohnaka" },
        { n: "69", name: "Asajj Ventress" },
        { n: "70", name: "Fives" },
        { n: "71", name: "Echo" },
        { n: "72", name: "General Grievous" },
        { n: "73", name: "Count Dooku" },
        { n: "74", name: "Kit Fisto" },
        { n: "75", name: "Ki-Adi-Mundi" },
        { n: "76", name: "Shaak Ti" },
        { n: "77", name: "Quinlan Vos" },
        { n: "78", name: "Aurra Sing" },
        { n: "79", name: "Mother Talzin" },
        { n: "80", name: "Admiral Trench" },
        { n: "81", name: "Jyn Erso" },
        { n: "82", name: "Captain Cassian Andor" },
        { n: "83", name: "K-2SO" },
        { n: "84", name: "Bodhi Rook" },
        { n: "85", name: "Baze Malbus" },
        { n: "86", name: "Chirrut Îmwe" },
        { n: "87", name: "Director Krennic" },
        { n: "88", name: "Pao" },
        { n: "89", name: "Death Trooper" },
        { n: "90", name: "Imperial Shoretrooper" },
        { n: "91", name: "Han Solo" },
        { n: "92", name: "Qi'ra" },
        { n: "93", name: "Chewbacca" },
        { n: "94", name: "Lando Calrissian" },
        { n: "95", name: "Tobias Beckett" },
        { n: "96", name: "Dryden Vos" },
        { n: "97", name: "Val" },
        { n: "98", name: "Rio Durant" },
        { n: "99", name: "L3-37" },
        { n: "100", name: "Enfys Nest" },
    ],
  },
  {
    id: "jumbo-costume-relic-cards",
    type: "insert",
    title: "JUMBO COSTUME RELIC CARDS",
    parallels: [
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "CR-AC", name: "Air Traffic Controller - Apron" },
        { n: "CR-BB", name: "Beckett - Coat" },
        { n: "CR-BC", name: "Beckett - Skiff Guard Cape" },
        { n: "CR-BT", name: "Beckett - Trench Coat" },
        { n: "CR-EN", name: "Enfys Nest - Cape Collar" },
        { n: "CR-ENC", name: "Enfys Nest - Cape" },
        { n: "CR-ENL", name: "Enfys Nest - Lappets" },
        { n: "CR-HSC", name: "Han Solo - Waistcoat" },
        { n: "CR-HSJ", name: "Han Solo - Jacket Yoke" },
        { n: "CR-HSL", name: "Han Solo - Jacket" },
        { n: "CR-KJ", name: "Korso - Jacket" },
        { n: "CR-KO", name: "Korso - Overcoat" },
        { n: "CR-QB", name: "Qi'ra - Blouse" },
        { n: "CR-QD", name: "Qi'ra - Dress Lining" },
        { n: "CR-WW", name: "Rebolt - Uniform" },
    ],
  },
  {
    id: "defining-moments",
    type: "insert",
    title: "DEFINING MOMENTS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DM-1", name: "Luke Skywalker" },
        { n: "DM-2", name: "Han Solo" },
        { n: "DM-3", name: "Princess Leia Organa" },
        { n: "DM-4", name: "Anakin Skywalker" },
        { n: "DM-5", name: "Obi-Wan Kenobi" },
        { n: "DM-6", name: "Boba Fett" },
        { n: "DM-7", name: "Chewbacca" },
        { n: "DM-8", name: "Lando Calrissian" },
        { n: "DM-9", name: "Emperor Palpatine" },
        { n: "DM-10", name: "Darth Vader" },
        { n: "DM-11", name: "Grand Moff Tarkin" },
        { n: "DM-12", name: "Padmé Amidala" },
        { n: "DM-13", name: "C-3PO" },
        { n: "DM-14", name: "R2-D2" },
        { n: "DM-15", name: "Qui-Gon Jinn" },
        { n: "DM-16", name: "Yoda" },
        { n: "DM-17", name: "Mace Windu" },
        { n: "DM-18", name: "Darth Maul" },
        { n: "DM-19", name: "Rey" },
        { n: "DM-20", name: "Finn" },
        { n: "DM-21", name: "Poe Dameron" },
        { n: "DM-22", name: "Kylo Ren" },
        { n: "DM-23", name: "Lieutenant Connix" },
        { n: "DM-24", name: "Vice Admiral Holdo" },
        { n: "DM-25", name: "Rose Tico" },
    ],
  },
  {
    id: "the-dark-side",
    type: "insert",
    title: "THE DARK SIDE",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DS-1", name: "Darth Vader" },
        { n: "DS-2", name: "Darth Sidious" },
        { n: "DS-3", name: "Darth Maul" },
        { n: "DS-4", name: "Count Dooku" },
        { n: "DS-5", name: "Kylo Ren" },
        { n: "DS-6", name: "Supreme Leader Snoke" },
        { n: "DS-7", name: "Asajj Ventress" },
        { n: "DS-8", name: "Savage Opress" },
        { n: "DS-9", name: "The Grand Inquisitor" },
        { n: "DS-10", name: "Seventh Sister" },
    ],
  },
  {
    id: "film-cel-relic-cards",
    type: "insert",
    title: "FILM CEL RELIC CARDS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FC-AA6", name: "Admiral Ackbar (Star Wars: Return of the Jedi)" },
        { n: "FC-AP5", name: "Admiral Piett (Star Wars: The Empire Strikes Back)" },
        { n: "FC-B6", name: "Bib Fortuna (Star Wars: Return of the Jedi)" },
        { n: "FC-BF5", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "FC-BF6", name: "Boba Fett (Star Wars: Return of the Jedi)" },
        { n: "FC-C4", name: "Chewbacca (Star Wars: A New Hope)" },
        { n: "FC-C5", name: "Chewbacca (Star Wars: The Empire Strikes Back)" },
        { n: "FC-C6", name: "Chewbacca (Star Wars: Return of the Jedi)" },
        { n: "FC-CP5", name: "C-3PO (Star Wars: The Empire Strikes Back)" },
        { n: "FC-CP6", name: "C-3PO (Star Wars: Return of the Jedi)" },
        { n: "FC-DV5", name: "Darth Vader (Star Wars: The Empire Strikes Back)" },
        { n: "FC-DV6", name: "Darth Vader (Star Wars: Return of the Jedi)" },
        { n: "FC-EP5", name: "Emperor Palpatine (Star Wars: The Empire Strikes Back)" },
        { n: "FC-EP6", name: "Emperor Palpatine (Star Wars: Return of the Jedi)" },
        { n: "FC-HS4", name: "Han Solo (Star Wars: A New Hope)" },
        { n: "FC-HS5", name: "Han Solo (Star Wars: The Empire Strikes Back)" },
        { n: "FC-HS6", name: "Han Solo (Star Wars: Return of the Jedi)" },
        { n: "FC-JH6", name: "Jabba The Hutt (Star Wars: Return of the Jedi)" },
        { n: "FC-LB6", name: "Boushh (Star Wars: Return of the Jedi)" },
        { n: "FC-LC5", name: "Lando Calrissian (Star Wars: The Empire Strikes Back)" },
        { n: "FC-LC6", name: "Lando Calrissian (Star Wars: Return of the Jedi)" },
        { n: "FC-LS4", name: "Luke Skywalker (Star Wars: A New Hope)" },
        { n: "FC-LS5", name: "Luke Skywalker (Star Wars: The Empire Strikes Back)" },
        { n: "FC-LS6", name: "Luke Skywalker (Star Wars: Return of the Jedi)" },
        { n: "FC-MJ6", name: "Moff Jerjerrod (Star Wars: Return of the Jedi)" },
        { n: "FC-MR6", name: "Sy Snootles (Star Wars: Return of the Jedi)" },
        { n: "FC-NN6", name: "Nien Nunb (Star Wars: Return of the Jedi)" },
        { n: "FC-O6", name: "Oola (Star Wars: Return of the Jedi)" },
        { n: "FC-OK4", name: "Obi-Wan Kenobi (Star Wars: A New Hope)" },
        { n: "FC-OK6", name: "Obi-Wan Kenobi (Star Wars: Return of the Jedi)" },
        { n: "FC-PL4", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "FC-PL5", name: "Princess Leia Organa (Star Wars: The Empire Strikes Back)" },
        { n: "FC-PL6", name: "Princess Leia Organa (Star Wars: Return of the Jedi)" },
        { n: "FC-R25", name: "R2-D2 (Star Wars: The Empire Strikes Back)" },
        { n: "FC-R26", name: "R2-D2 (Star Wars: Return of the Jedi)" },
        { n: "FC-RC4", name: "R2-D2 & C-3PO (Star Wars: A New Hope)" },
        { n: "FC-SC6", name: "Salacious Crumb (Star Wars: Return of the Jedi)" },
        { n: "FC-TL6", name: "Logray (Star Wars: Return of the Jedi)" },
        { n: "FC-WW6", name: "Wicket (Star Wars: Return of the Jedi)" },
        { n: "FC-Y5", name: "Yoda (Star Wars: The Empire Strikes Back)" },
    ],
  },
  {
    id: "heroes-of-the-rebellion",
    type: "insert",
    title: "HEROES OF THE REBELLION",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "HR-1", name: "Luke Skywalker" },
        { n: "HR-2", name: "Han Solo" },
        { n: "HR-3", name: "Princess Leia Organa" },
        { n: "HR-4", name: "Chewbacca" },
        { n: "HR-5", name: "R2-D2" },
        { n: "HR-6", name: "General Rieekan" },
        { n: "HR-7", name: "Lando Calrissian" },
        { n: "HR-8", name: "Admiral Ackbar" },
        { n: "HR-9", name: "Jyn Erso" },
        { n: "HR-10", name: "Captain Cassian Andor" },
        { n: "HR-11", name: "Bodhi Rook" },
        { n: "HR-12", name: "Baze Malbus" },
        { n: "HR-13", name: "Chirrut Îmwe" },
        { n: "HR-14", name: "Admiral Raddus" },
        { n: "HR-15", name: "K-2SO" },
    ],
  },
  {
    id: "artifact-medallion-cards",
    type: "insert",
    title: "ARTIFACT MEDALLION CARDS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MC-ASB", name: "Anakin Skywalker - Queen Amidala's Belt Buckle" },
        { n: "MC-FR", name: "Finn - Rose Tico's Medallion" },
        { n: "MC-GJK", name: "Galen Erso - Jyn's Kyber Pendant" },
        { n: "MC-HBH", name: "Han Solo - Blast Shield Helmet" },
        { n: "MC-JK", name: "Jyn Erso - Jyn's Kyber Pendant" },
        { n: "MC-JRB", name: "Moff Jerjerrod - Imperial Rank Badge" },
        { n: "MC-KSR", name: "Kylo Ren - Snoke's Ring" },
        { n: "MC-LBH", name: "Luke Skywalker - Blast Shield Helmet" },
        { n: "MC-LJK", name: "Lyra Erso - Jyn's Kyber Pendant" },
        { n: "MC-LSC", name: "Luke Skywalker - Luke's Compass" },
        { n: "MC-LSY", name: "Luke Skywalker - Yoda's Necklace" },
        { n: "MC-MRB", name: "Grand Moff Tarkin - Imperial Rank Badge" },
        { n: "MC-MSC", name: "Darth Maul - Sith Chalice" },
        { n: "MC-OBH", name: "Obi-Wan Kenobi - Blast Shield Helmet" },
        { n: "MC-ORB", name: "Admiral Ozzel - Imperial Rank Badge" },
        { n: "MC-PDN", name: "Poe Dameron - Poe Dameron's Necklace" },
        { n: "MC-PR", name: "Paige Tico - Rose Tico's Medallion" },
        { n: "MC-PRB", name: "Admiral Piett - Imperial Rank Badge" },
        { n: "MC-PSC", name: "Supreme Chancellor Palpatine - Sith Chalice" },
        { n: "MC-QAB", name: "Queen Amidala - Queen Amidala's Belt Buckle" },
        { n: "MC-R2C", name: "R2-D2 - Luke's Compass" },
        { n: "MC-R2Y", name: "R2-D2 - Yoda's Necklace" },
        { n: "MC-RLC", name: "Rey - Luke's Compass" },
        { n: "MC-RR", name: "Rose Tico - Rose Tico's Medallion" },
        { n: "MC-RSR", name: "Rey - Snoke's Ring" },
        { n: "MC-SD", name: "Han Solo - Han Solo's Dice" },
        { n: "MC-SSB", name: "Sabé - Queen Amidala's Belt Buckle" },
        { n: "MC-SSR", name: "Supreme Leader Snoke - Snoke's Ring" },
        { n: "MC-VRB", name: "General Veers - Imperial Rank Badge" },
        { n: "MC-VSC", name: "Darth Vader - Sith Chalice" },
        { n: "MC-YN", name: "Yoda - Yoda's Necklace" },
    ],
  },
  {
    id: "animated-signers",
    type: "auto",
    title: "ANIMATED SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWA-AS-1", name: "Freddie Prinze Jr. as Kanan Jarrus" },
        { n: "MWA-AS-2", name: "Ron Perlman as Gha Nachkt" },
        { n: "MWA-AS-3", name: "Tim Curry as Chancellor Palpatine" },
        { n: "MWA-AS-4", name: "David Tennant as Professor Huyang" },
        { n: "MWA-AS-5", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "MWA-AS-6", name: "Donald Faison as Hype Fazon" },
        { n: "MWA-AS-7", name: "Jason Isaacs as The Grand Inquisitor" },
        { n: "MWA-AS-8", name: "Paul Reubens as RX-24" },
        { n: "MWA-AS-9", name: "Bobby Moynihan as Orka" },
        { n: "MWA-AS-10", name: "Christopher Sean as Kazuda Xiono" },
        { n: "MWA-AS-11", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "MWA-AS-12", name: "James Arnold Taylor as Obi-Wan Kenobi" },
        { n: "MWA-AS-13", name: "Matt Lanter as Anakin Skywalker" },
        { n: "MWA-AS-14", name: "Mary Elizabeth McGlynn as Freya Fenris" },
        { n: "MWA-AS-15", name: "Tovah Feldshuh as Aunt Z" },
        { n: "MWA-AS-16", name: "Dee Bradley Baker as Grevel" },
        { n: "MWA-AS-17", name: "Myrna Velasco as Torra Doza" },
        { n: "MWA-AS-18", name: "Scott Lawrence as Jarek Yeager" },
        { n: "MWA-AS-19", name: "Suzie McGrath as Tam Ryvora" },
        { n: "MWA-AS-20", name: "Josh Brener as Neeku Vozo" },
        { n: "MWA-AS-21", name: "Nazneen Contractor as Synara San" },
        { n: "MWA-AS-22", name: "Fred Tatasciore as Bolza Grool" },
        { n: "MWA-AS-23", name: "Lex Lang as Major Elrik Vonreg" },
        { n: "MWA-AS-24", name: "Katee Sackhoff as Bo-Katan Kryze" },
    ],
  },
  {
    id: "classic-era-signers",
    type: "auto",
    title: "CLASSIC ERA SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-CS-1", name: "Harrison Ford as Han Solo" },
        { n: "MWA-CS-2", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "MWA-CS-3", name: "Jeremy Bulloch as Boba Fett" },
        { n: "MWA-CS-4", name: "Mark Austin as Boba Fett" },
        { n: "MWA-CS-5", name: "Clive Revill as Voice of The Emperor" },
        { n: "MWA-CS-6", name: "Denis Lawson as Wedge Antilles" },
        { n: "MWA-CS-7", name: "Michael Pennington as Moff Jerjerrod" },
    ],
  },
  {
    id: "new-trilogy-signers",
    type: "auto",
    title: "NEW TRILOGY SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-NT-1", name: "Daisy Ridley as Rey" },
        { n: "MWA-NT-2", name: "Adam Driver as Kylo Ren" },
        { n: "MWA-NT-3", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "MWA-NT-4", name: "Laura Dern as Vice Admiral Amilyn Holdo" },
        { n: "MWA-NT-5", name: "Gwendoline Christie as Captain Phasma" },
        { n: "MWA-NT-6", name: "Kelly Marie Tran as Rose Tico" },
        { n: "MWA-NT-7", name: "Domhnall Gleeson as General Hux" },
        { n: "MWA-NT-8", name: "Billie Lourd as Kaydel Ko Connix" },
        { n: "MWA-NT-9", name: "Joonas Suotamo as Chewbacca" },
        { n: "MWA-NT-10", name: "Jimmy Vee as R2-D2" },
    ],
  },
  {
    id: "prequel-era-signers",
    type: "auto",
    title: "PREQUEL ERA SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-PE-1", name: "Ewan McGregor as Obi-Wan Kenobi" },
        { n: "MWA-PE-2", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "MWA-PE-3", name: "Ian McDiarmid as Supreme Chancellor Palpatine" },
        { n: "MWA-PE-4", name: "Ahmed Best as Jar Jar Binks" },
        { n: "MWA-PE-5", name: "Matthew Wood as General Grievous" },
        { n: "MWA-PE-6", name: "Temuera Morrison as Jango Fett" },
    ],
  },
  {
    id: "rogue-one-signers",
    type: "auto",
    title: "ROGUE ONE SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-RO-1", name: "Forest Whitaker as Saw Gerrera" },
        { n: "MWA-RO-2", name: "Riz Ahmed as Bodhi Rook" },
        { n: "MWA-RO-3", name: "Alan Tudyk as K-2SO" },
        { n: "MWA-RO-4", name: "Mads Mikkelsen as Galen Erso" },
        { n: "MWA-RO-5", name: "Donnie Yen as Chirrut Îmwe" },
    ],
  },
  {
    id: "solo-signers",
    type: "auto",
    title: "SOLO SIGNERS",
    parallels: [
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-SS-1", name: "Alden Ehrenreich as Han Solo" },
        { n: "MWA-SS-2", name: "Paul Bettany as Dryden Vos" },
        { n: "MWA-SS-3", name: "Ray Park as Maul" },
        { n: "MWA-SS-4", name: "Sam Witwer as Voice of Maul" },
        { n: "MWA-SS-5", name: "Stephanie Silva as S1D6-SA-5" },
        { n: "MWA-SS-6", name: "Charlotte Louise as Margo" },
        { n: "MWA-SS-7", name: "Katy Kartwheel as Performer for Rio Durant" },
    ],
  },
  {
    id: "artifact-medallion-autograph-cards",
    type: "auto",
    title: "ARTIFACT MEDALLION AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "AMA-1", name: "Harrison Ford as Han Solo - Han Solo's Dice" },
        { n: "AMA-2", name: "Kenny Baker as R2-D2 - Yoda's Necklace" },
        { n: "AMA-3", name: "Kelly Marie Tran as Rose Tico - Rose Tico's Medallion" },
        { n: "AMA-4", name: "John Boyega as Finn - Rose Tico's Medallion" },
        { n: "AMA-5", name: "Daisy Ridley as Rey - Luke's Compass" },
        { n: "AMA-6", name: "Felicity Jones as Jyn Erso - Jyn's Kyber Pendant" },
        { n: "AMA-7", name: "Valene Kane as Lyra Erso - Jyn's Kyber Pendant" },
        { n: "AMA-8", name: "Mads Mikkelsen as Galen Erso - Jyn's Kyber Pendant" },
        { n: "AMA-9", name: "Adam Driver as Kylo Ren - Snoke's Ring" },
        { n: "AMA-10", name: "Daisy Ridley as Rey - Snoke's Ring" },
        { n: "AMA-11", name: "Hayden Christensen as Anakin Skywalker - Amidala's Belt Buckle" },
        { n: "AMA-12", name: "Ray Park as Darth Maul - Sith Chalice" },
        { n: "AMA-13", name: "Kenneth Colley as Admiral Piett - Imperial Rank Badge" },
        { n: "AMA-14", name: "Julian Glover as General Veers - Imperial Rank Badge" },
        { n: "AMA-15", name: "Michael Pennington as Moff Jerjerrod - Imperial Rank Badge" },
        { n: "AMA-16", name: "Guy Henry as Grand Moff Tarkin - Imperial Rank Badge" },
    ],
  },
  {
    id: "dual-autograph-cards",
    type: "auto",
    title: "DUAL AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWD-1", name: "Ewan McGregor / Hayden Christensen as Obi-Wan Kenobi / Anakin Skywalker" },
        { n: "MWD-2", name: "Hayden Christensen / Samuel L. Jackson as Anakin Skywalker / Mace Windu" },
        { n: "MWD-3", name: "Daisy Ridley / Adam Driver as Rey / Kylo Ren" },
        { n: "MWD-4", name: "Billy Dee Williams / Peter Mayhew as Lando Calrissian / Chewbacca" },
        { n: "MWD-5", name: "Alden Ehrenreich / Paul Bettany as Han Solo / Dryden Vos" },
        { n: "MWD-6", name: "Alden Ehrenreich / Joonas Suotamo as Han Solo / Chewbacca" },
        { n: "MWD-7", name: "Andy Serkis / Domhnall Gleeson as Supreme Leader Snoke / General Hux" },
        { n: "MWD-8", name: "Felicity Jones / Ben Mendelsohn as Jyn Erso / Director Krennic" },
        { n: "MWD-9", name: "Riz Ahmed / Forest Whitaker as Bodhi Rook / Saw Gerrera" },
        { n: "MWD-10", name: "Ben Mendelsohn / Mads Mikkelsen as Director Krennic / Galen Erso" },
        { n: "MWD-11", name: "John Boyega / Kelly Marie Tran as Finn / Rose Tico" },
        { n: "MWD-12", name: "Christopher Sean / Suzie McGrath as Kazuda Xiono / Tam Ryvora" },
        { n: "MWD-13", name: "Myrna Velasco / Donald Faison as Torra Doza / Hype Fazon" },
        { n: "MWD-14", name: "Scott Lawrence / Suzie McGrath as Jarek Yeager / Tam Ryvora" },
        { n: "MWD-15", name: "Mary Elizabeth McGlynn / Stephen Stanton as Freya Fenris / Griff Halloran" },
        { n: "MWD-16", name: "Christopher Sean / Lex Lang as Kazuda Xiono / Major Baron Elrik Vonreg" },
        { n: "MWD-17", name: "Garrick Hagon / Anthony Forrest as Biggs Darklighter / Fixer" },
        { n: "MWD-18", name: "Simon Williamson / Deep Roy as puppeteer for Max Rebo / Droopy McCool" },
        { n: "MWD-19", name: "Greg Proops / Scott Capurro as Fode / Beed" },
        { n: "MWD-20", name: "Oliver Ford Davies / Hugh Quarshie as Governor Sio Bibble / Captain Panaka" },
        { n: "MWD-21", name: "Andrew Jack / Ian Kenny as voice of Moloch / Rebolt" },
        { n: "MWD-22", name: "Derek Arnold / Nick Kellington as Pao / Bistan" },
        { n: "MWD-23", name: "Arti Shah / Aidan Cook as Gwellis Bagnoro / Strono \"Cookie\" Tuggs" },
        { n: "MWD-24", name: "Lily Cole / Kiran Shah as Lovey / Neepers Panpick" },
        { n: "MWD-25", name: "Jason Isaacs / Taylor Gray as The Grand Inquisitor / Ezra Bridger" },
        { n: "MWD-26", name: "Sarah Michelle Gellar / Sam Witwer as Seventh Sister / Maul" },
        { n: "MWD-27", name: "Lars Mikkelsen / Keone Young as Thrawn / Commander Sato" },
        { n: "MWD-28", name: "Tim Curry / Sam Witwer as Darth Sidious / Darth Maul" },
        { n: "MWD-29", name: "Matt Lanter / Lloyd Sherr as Anakin Skywalker / Mortis Father" },
        { n: "MWD-30", name: "Michael Pennington / Julian Glover as Moff Jerjerrod / General Veers" },
        { n: "MWD-31", name: "Jason Spisak / Kath Soucie as Lux Bonteri / Mina Bonteri" },
    ],
  },
  {
    id: "quad-autographs",
    type: "auto",
    title: "QUAD AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWQ-1", name: "Harrison Ford / Carrie Fisher / Daisy Ridley / Adam Driver" },
        { n: "MWQ-2", name: "Freddie Prinze Jr. / Taylor Gray / Jason Isaacs / Sarah Michelle Gellar" },
        { n: "MWQ-3", name: "Alden Ehrenreich / Joonas Suotamo / Erin Kellyman / Warwick Davis" },
        { n: "MWQ-4", name: "Felicity Jones / Forest Whitaker / Donnie Yen / Alan Tudyk" },
    ],
  },
  {
    id: "triple-autograph-cards",
    type: "auto",
    title: "TRIPLE AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "canvas", name: "Canvas", print_run: null, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWT-1", name: "Harrison Ford / Billy Dee Williams / Peter Mayhew" },
        { n: "MWT-2", name: "Ewan McGregor / Samuel L. Jackson / Hayden Christensen" },
        { n: "MWT-3", name: "Adam Driver / Domhnall Gleeson / Andy Serkis" },
        { n: "MWT-4", name: "Daisy Ridley / John Boyega / Laura Dern" },
        { n: "MWT-5", name: "Alden Ehrenreich / Paul Bettany / Joonas Suotamo" },
        { n: "MWT-6", name: "Felicity Jones / Ben Mendelsohn / Mads Mikkelsen" },
        { n: "MWT-7", name: "Peter Mayhew / Anthony Daniels / Kenny Baker" },
        { n: "MWT-8", name: "Felicity Jones / Alan Tudyk / Riz Ahmed" },
        { n: "MWT-9", name: "Taylor Gray / Tiya Sircar / Ashley Eckstein" },
        { n: "MWT-10", name: "Christopher Sean / Suzie McGrath / Scott Lawrence" },
    ],
  },
  {
    id: "ultimate-autograph-book-card",
    type: "auto",
    title: "ULTIMATE AUTOGRAPH BOOK CARD",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWUB-1", name: "Harrison Ford / Carrie Fisher / Billy Dee Williams / Peter Mayhew / Kenny Baker / Anthony Daniels / Hayden Christensen / Samuel L. Jackson / Ewan McGregor / Ahmed Best / Ian McDiarmid / Ray Park / Felicity Jones / Mads Mikkelsen / Forest Whitaker / Donnie Yen / Riz Ahmed / Alan Tudyk / Ben Mendelsohn / Genevieve O'Reilly / Freddie Prinze Jr. / Jason Isaacs / Matt Lanter / James Arnold Taylor / Ashley Eckstein / Dee Bradley Baker / Daisy Ridley / Adam Driver / John Boyega / Kelly Marie Tran / Domhnall Gleeson / Gwendoline Christie / Billie Lourd / Laura Dern / Alden Ehrenreich / Joonas Suotamo / Paul Bettany / Sam Witwer / Erin Kellyman / Warwick Davis" },
    ],
  },
  {
    id: "pen-relic-autographs",
    type: "auto",
    title: "PEN RELIC AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PRA-1", name: "Harrison Ford as Han Solo" },
        { n: "PRA-2", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "PRA-3", name: "Jeremy Bulloch as Boba Fett" },
        { n: "PRA-4", name: "Mark Austin as Boba Fett" },
        { n: "PRA-5", name: "Denis Lawson as Wedge Antilles" },
        { n: "PRA-6", name: "Ian McDiarmid as Supreme Chancellor Palpatine" },
        { n: "PRA-7", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "PRA-8", name: "Matthew Wood as General Grievous" },
        { n: "PRA-9", name: "Ahmed Best as Jar Jar Binks" },
        { n: "PRA-10", name: "Daisy Ridley as Rey" },
        { n: "PRA-11", name: "Adam Driver as Kylo Ren" },
        { n: "PRA-12", name: "Andy Serkis as Supreme Leader Snoke" },
        { n: "PRA-13", name: "Laura Dern as Vice Admiral Amilyn Holdo" },
        { n: "PRA-14", name: "Gwendoline Christie as Captain Phasma" },
        { n: "PRA-15", name: "Billie Lourd as Kaydel Ko Connix" },
        { n: "PRA-16", name: "Katy Kartwheel as Performer for Rio Durant" },
        { n: "PRA-17", name: "Forest Whitaker as Saw Gerrera" },
        { n: "PRA-18", name: "Domhnall Gleeson as General Hux" },
        { n: "PRA-19", name: "Riz Ahmed as Bodhi Rook" },
        { n: "PRA-20", name: "Alan Tudyk as K-2SO" },
        { n: "PRA-21", name: "Mads Mikkelsen as Galen Erso" },
        { n: "PRA-22", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "PRA-23", name: "Jason Isaacs as The Grand Inquisitor" },
        { n: "PRA-24", name: "Paul Reubens as RX-24" },
        { n: "PRA-25", name: "Christopher Sean as Kazuda Xiono" },
        { n: "PRA-26", name: "Mary Elizabeth McGlynn as Freya Fenris" },
        { n: "PRA-27", name: "Tovah Feldshuh as Aunt Z" },
        { n: "PRA-28", name: "Dee Bradley Baker as Grevel" },
        { n: "PRA-29", name: "Myrna Velasco as Torra Doza" },
        { n: "PRA-30", name: "Scott Lawrence as Jarek Yeager" },
        { n: "PRA-31", name: "Suzie McGrath as Tam Ryvora" },
        { n: "PRA-32", name: "Bobby Moynihan as Orka" },
        { n: "PRA-33", name: "Donald Faison as Hype Fazon" },
        { n: "PRA-34", name: "Lex Lang as Major Elrik Vonreg" },
        { n: "PRA-35", name: "Ray Park as Maul" },
        { n: "PRA-36", name: "Sam Witwer as Voice of Maul" },
        { n: "PRA-37", name: "Paul Bettany as Dryden Vos" },
        { n: "PRA-38", name: "Michael Pennington as Moff Jerjerrod" },
        { n: "PRA-39", name: "Charlotte Louise as Margo" },
        { n: "PRA-40", name: "Joonas Suotamo as Chewbacca" },
        { n: "PRA-41", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "PRA-42", name: "James Arnold Taylor as Obi-Wan Kenobi" },
        { n: "PRA-43", name: "Freddie Prinze Jr. as Kanan Jarrus" },
        { n: "PRA-44", name: "Matt Lanter as Anakin Skywalker" },
        { n: "PRA-45", name: "Donnie Yen as Chirrut Îmwe" },
        { n: "PRA-46", name: "Temuera Morrison as Jango Fett" },
        { n: "PRA-47", name: "Kelly Marie Tran as Rose Tico" },
        { n: "PRA-48", name: "Ron Perlman as Gha Nachkt" },
        { n: "PRA-49", name: "Tim Curry as Chancellor Palpatine" },
        { n: "PRA-50", name: "Ewan McGregor as Obi-Wan Kenobi" },
        { n: "PRA-51", name: "Alden Ehrenreich as Han Solo" },
        { n: "PRA-52", name: "David Tennant as Professor Huyang" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Jeff Abar" },
        { n: "SK-2", name: "Ben AbuSaada" },
        { n: "SK-3", name: "Jason Adams" },
        { n: "SK-4", name: "Marlo Agunos" },
        { n: "SK-5", name: "Steve Alce" },
        { n: "SK-6", name: "Nick Allsopp" },
        { n: "SK-7", name: "Thomas Amici" },
        { n: "SK-8", name: "Kallan Archer" },
        { n: "SK-9", name: "Andrew Arensberg" },
        { n: "SK-10", name: "Colin Arthurs" },
        { n: "SK-11", name: "Laura Atkinson" },
        { n: "SK-12", name: "Angel Aviles" },
        { n: "SK-13", name: "Kelly Baber" },
        { n: "SK-14", name: "Can Baran" },
        { n: "SK-15", name: "Jonathan Beistline" },
        { n: "SK-16", name: "Angelina Benedetti" },
        { n: "SK-17", name: "Rachel Brady" },
        { n: "SK-18", name: "Ashlee Brienzo" },
        { n: "SK-19", name: "John Bruce" },
        { n: "SK-20", name: "Carlos Cabaleiro" },
        { n: "SK-21", name: "Neil Camera" },
        { n: "SK-22", name: "Patricio Carrasco" },
        { n: "SK-23", name: "Başak Çetinkaya" },
        { n: "SK-24", name: "Josh Church" },
        { n: "SK-25", name: "Kevin Cleveland" },
        { n: "SK-26", name: "Jamie Cosley" },
        { n: "SK-27", name: "Carolyn Craggs" },
        { n: "SK-28", name: "Ronnie Crowther" },
        { n: "SK-29", name: "Candice Dailey" },
        { n: "SK-30", name: "Ted Dastick Jr." },
        { n: "SK-31", name: "John DiBiase" },
        { n: "SK-32", name: "Vincenzo D'Ippolito" },
        { n: "SK-33", name: "Garrett Dix" },
        { n: "SK-34", name: "Tim Dowler" },
        { n: "SK-35", name: "Louise Draper" },
        { n: "SK-36", name: "Dean Drummond" },
        { n: "SK-37", name: "Marcia Dye" },
        { n: "SK-38", name: "Antni Ellison" },
        { n: "SK-39", name: "Keith Farnum" },
        { n: "SK-40", name: "Anthony Figaro" },
        { n: "SK-41", name: "Ryan Finley" },
        { n: "SK-42", name: "Andrew Fry" },
        { n: "SK-43", name: "Jude Gallagher" },
        { n: "SK-44", name: "Gerard Garcia Jr." },
        { n: "SK-45", name: "Bruce Gerlach" },
        { n: "SK-46", name: "Mick and Matt Glebe" },
        { n: "SK-47", name: "Sammy Gomez" },
        { n: "SK-48", name: "Fredd Gorham" },
        { n: "SK-49", name: "Dan Gorman" },
        { n: "SK-50", name: "Lindsey Greyling" },
        { n: "SK-51", name: "Seth Groves" },
        { n: "SK-52", name: "Ingrid Hardy" },
        { n: "SK-53", name: "Phil Hassewer" },
        { n: "SK-54", name: "Robert Hendrickson" },
        { n: "SK-55", name: "Rich Hennemann" },
        { n: "SK-56", name: "Jessica Hickman" },
        { n: "SK-57", name: "Kyle Hickman" },
        { n: "SK-58", name: "Matthew Hirons" },
        { n: "SK-59", name: "Brad Hudson" },
        { n: "SK-60", name: "Lee Hunt" },
        { n: "SK-61", name: "Alex Iniguez" },
        { n: "SK-62", name: "Sheikh Islam" },
        { n: "SK-63", name: "Mike James" },
        { n: "SK-64", name: "Darren James" },
        { n: "SK-65", name: "Mohammad Jilani" },
        { n: "SK-66", name: "Andrew Joynes" },
        { n: "SK-67", name: "Frank Kadar" },
        { n: "SK-68", name: "Chris Kay" },
        { n: "SK-69", name: "Caleb King" },
        { n: "SK-70", name: "Lee Kohse" },
        { n: "SK-71", name: "Matt Langford" },
        { n: "SK-72", name: "Eric Lehtonen" },
        { n: "SK-73", name: "Ian MacDougall" },
        { n: "SK-74", name: "Erik Maell" },
        { n: "SK-75", name: "Jay Manchand" },
        { n: "SK-76", name: "Ashley Marsh" },
        { n: "SK-77", name: "Laura Martin" },
        { n: "SK-78", name: "Michael Mastermaker" },
        { n: "SK-79", name: "Chris Meeks" },
        { n: "SK-80", name: "Jim Mehsling" },
        { n: "SK-81", name: "Lloyd Mills" },
        { n: "SK-82", name: "Solly Mohamed" },
        { n: "SK-83", name: "Rich Molinelli" },
        { n: "SK-84", name: "Logan Monette" },
        { n: "SK-85", name: "Jamie Murdock" },
        { n: "SK-86", name: "Ryan Olsen" },
        { n: "SK-87", name: "Jim O'Riley" },
        { n: "SK-88", name: "Marsha Parkins" },
        { n: "SK-89", name: "Darrin Pepe" },
        { n: "SK-90", name: "Steve Potter" },
        { n: "SK-91", name: "Jason Queen" },
        { n: "SK-92", name: "Michelle Rayner" },
        { n: "SK-93", name: "Jamie Richards" },
        { n: "SK-94", name: "Tony Riley" },
        { n: "SK-95", name: "Cisco Rivera" },
        { n: "SK-96", name: "Rodney Roberts" },
        { n: "SK-97", name: "Omar Salinas" },
        { n: "SK-98", name: "Ryan Santos" },
        { n: "SK-99", name: "Michael Sealie" },
        { n: "SK-100", name: "Richard Serrao" },
        { n: "SK-101", name: "Mayumi Seto" },
        { n: "SK-102", name: "Anil Sharma" },
        { n: "SK-103", name: "Rebecca Sharp" },
        { n: "SK-104", name: "Liam Shaw" },
        { n: "SK-105", name: "Paul Shiers" },
        { n: "SK-106", name: "Tim Shinn" },
        { n: "SK-107", name: "Shaow Siong" },
        { n: "SK-108", name: "James Henry Smith" },
        { n: "SK-109", name: "Todd Aaron Smith" },
        { n: "SK-110", name: "Vernoica Smith" },
        { n: "SK-111", name: "Doug Snodgrass" },
        { n: "SK-112", name: "Mike Stephens" },
        { n: "SK-113", name: "Dan Tearle" },
        { n: "SK-114", name: "Rob Teranishi" },
        { n: "SK-115", name: "Cameron Tobias" },
        { n: "SK-116", name: "Phillip Trujillo" },
        { n: "SK-117", name: "Huy Truong" },
        { n: "SK-118", name: "Jose Ventura" },
        { n: "SK-119", name: "Kevin P. West" },
        { n: "SK-120", name: "Trent Westbrook" },
        { n: "SK-121", name: "Gavin Williams" },
        { n: "SK-122", name: "Zach Woolsey" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
